module.exports = __webpack_public_path__ + "static/media/aboutus-1.e76b14cb.jpg";